import { Deserializable } from '../../protocols/deserializable';
import { LookAheadItem } from '../../../views/shared/components/search-with-look-ahead/look-ahead-list/look-ahead-item/protocol/look-ahead-item';
import { EmployeeTableUserEmploymentHistory } from './employee-table-user-employment-history';
import { EmployeeTableUserLastContributionDetails } from './employee-table-user-last-contribution-details';

export class EmployeeTableUser implements Deserializable, LookAheadItem {
  public id!: number;
  public firstName!: string;
  public lastName!: string;
  public socialInsuranceNumber!: string;
  public employmentDetails!: EmployeeTableUserEmploymentHistory;
  public lastContributionDetails!: EmployeeTableUserLastContributionDetails;

  // Not returned from API
  public fullName!: string;

  onDeserialize(): void {
    this.fullName = `${this?.firstName} ${this?.lastName}`.trim();

    const Deserialize = window?.injector?.Deserialize;

    if (this.employmentDetails) {
      this.employmentDetails = Deserialize?.instanceOf(EmployeeTableUserEmploymentHistory, this.employmentDetails);
    }

    if (this.lastContributionDetails) {
      this.lastContributionDetails = Deserialize?.instanceOf(
        EmployeeTableUserLastContributionDetails,
        this.lastContributionDetails
      );
    }
  }

  // Look ahead item interface
  lookAheadDisabled(): boolean {
    return false;
  }

  lookAheadDisabledMessage(): string {
    return 'disabled';
  }
}
